<template>
  <div class="catalog-filter__badges">
    <button
      class="catalog-filter__badges__item"
      :class="{applied: productConditionNew}"
      :disabled="!availableFilters.productCondition?.includes(1)"
      @click="applyProductCondition"
    >
      <UIIcon
        class="mr-1.5"
        :class="productCondition.id"
        :name="productCondition.iconName"
      />
      {{ productCondition.name }}
    </button>
    <button
      class="catalog-filter__badges__item"
      :class="{applied: route.query[oskellyChoiceBadge.id] === 'true'}"
      :disabled="availableFilters.hasOurChoice === false"
      @click="applyBadgeFilter(oskellyChoiceBadge.id, oskellyChoiceBadge.value)"
    >
      <UIIcon
        class="mr-1.5"
        :class="oskellyChoiceBadge.id"
        :name="oskellyChoiceBadge.iconName"
      />
      {{ oskellyChoiceBadge.name }}
    </button>
    <button
      class="catalog-filter__badges__item"
      :class="{applied: viewOneColumn}"
      @click="emit('update:view-one-column', !viewOneColumn)"
    >
      <UIIcon
        name="slide"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useFilterBadges, productCondition } from '~/services/catalogFilter/badges';
import UIIcon from '~/components/ui/UIIcon.vue';
import {
  useAvailableFilters,
} from '~/services/catalogFilter/useAvailableFilters';
import { useCategoriesFilter } from '~/services/catalogFilter/categories';
import { useSizesFilter } from '~/services/catalogFilter/sizes';

const props = defineProps<{
  pageInfo?: Record<string, any>,
  viewOneColumn: boolean,
  profileId?: number
}>();
const emit = defineEmits<{
  (e: 'update:view-one-column', value: boolean):void
}>();

const route = useRoute();
const router = useRouter();
const {
  productConditionNew, selectedFilters, getAvailableFilters, availableFilters,
  getAvailableFiltersWithRoute,
} = useAvailableFilters(route);
const { applyBadgeFilter, badges } = useFilterBadges(route, router, availableFilters);
const oskellyChoiceBadge = badges.find(({ id }) => id === 'hasOurChoice');

const { availableCategories } = useCategoriesFilter(route);
const { availableSizes } = useSizesFilter();

function applyProductCondition() {
  if (selectedFilters.value.productCondition?.includes(productCondition.value as number)) {
    selectedFilters.value.productCondition = selectedFilters.value.productCondition.filter((id) => productCondition.value !== id);
  } else {
    selectedFilters.value.productCondition?.push(productCondition.value as number);
  }

  fetchAvailableFilters();
  applyBadgeFilter(productCondition.id, productCondition.value);
}

async function fetchAvailableFilters() {
  let params;

  if (props.profileId) {
    params = { sellerId: props.profileId };
  } else {
    params = { ...props.pageInfo };
  }

  const res = await getAvailableFiltersWithRoute(params);

  availableCategories.value = res.category!;
  availableSizes.value = res.size!;
}

onMounted(fetchAvailableFilters);
</script>

<style scoped lang="scss">
@tailwind components;

@layer components {
  .catalog-filter__badges {
    display: flex;

    &__item {
      flex: 1 1 auto;
      justify-content: center;
      margin: 0 4px;

      @apply flex items-center h-8 text-[#333] text-xs px-2 border border-[#E5E5E5] rounded-sm;

      &.applied {
        @apply bg-[#ebebed4d];
      }

      &:disabled {
        color: #bdbdbd;
      }

      svg {
        &.productCondition {
          @apply opacity-60;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
</style>
